import { Alignments } from 'rich-text-lib/constants/alignments';
export const STYLE_OPTIONS = {
  [Alignments.LEFT]: {
    float: 'left',
    'margin-right': '20px'
  },
  [Alignments.CENTER]: {
    margin: '0 auto',
    display: 'block',
    'margin-top': '20px',
    'margin-bottom': '20px'
  },
  [Alignments.RIGHT]: {
    float: 'right',
    'margin-left': '20px'
  },
  [Alignments.NONE]: {
    float: null,
    margin: '0'
  }
};

// Important: only use these values for alignment in CTA Hubl, for the
// specification see https://designers.hubspot.com/docs/hubl/functions#cta
export const ALIGNMENTS_HUBL = {
  [Alignments.LEFT]: 'justifyleft',
  [Alignments.CENTER]: 'justifycenter',
  [Alignments.RIGHT]: 'justifyright'
};
export const TOKEN_PATTERN = /\{\{\s*cta\(([^)]+)\)\s*\}\}/gi;
export const getTokenPattern = () => new RegExp(TOKEN_PATTERN);
export const CTA_SETTINGS = 'hsCta';
export const hsctaConfig = {
  USE_NEW_CTAS: 'useNewCtas'
};